/* eslint-disable react/prop-types */
import React from 'react';
import Cotizador from './views/Cotizador';
import { CotizadorProvider } from './context';

const App = ({ legal_url, model_url, contact_url, car_id}) => {

    return (
        <CotizadorProvider>
            <Cotizador legal_url_path={legal_url} model_url_path={model_url} contact_url={contact_url} car_id={car_id}/>
        </CotizadorProvider>
    );
};

export default App;